import { TQuestionOption } from "../types";

export const yesNo: TQuestionOption[] = [
  {
    value: "yes",
    label: "Yes",
  },
  {
    value: "no",
    label: "No",
  },
];

export const yesNoUnsure: TQuestionOption[] = [
  {
    value: "yes",
    label: "Yes",
  },
  {
    value: "no",
    label: "No",
  },
  {
    value: "unsure",
    label: "Unsure",
  },
];

export const languages: TQuestionOption[] = [
  {
    value: "Albanian",
    label: "Albanian",
  },
  {
    value: "Amharic",
    label: "Amharic",
  },
  {
    value: "Arabic (incl.Lebanese)",
    label: "Arabic (incl.Lebanese)",
  },
  {
    value: "Assyrian (inc.Aramaic)",
    label: "Assyrian (inc.Aramaic)",
  },
  {
    value: "Auslan (Sign language)",
    label: "Auslan (Sign language)",
  },
  {
    value: "Bosnian",
    label: "Bosnian",
  },
  {
    value: "Burmese",
    label: "Burmese",
  },
  {
    value: "Cantonese",
    label: "Cantonese",
  },
  {
    value: "Croatian",
    label: "Croatian",
  },
  {
    value: "French",
    label: "French",
  },
  {
    value: "German",
    label: "German",
  },
  {
    value: "Greek",
    label: "Greek",
  },
  {
    value: "Hakka",
    label: "Hakka",
  },
  {
    value: "Hindi",
    label: "Hindi",
  },
  {
    value: "Hungarian",
    label: "Hungarian",
  },
  {
    value: "Indonesian",
    label: "Indonesian",
  },
  {
    value: "Italian",
    label: "Italian",
  },
  {
    value: "Japanese",
    label: "Japanese",
  },
  {
    value: "Khmer",
    label: "Khmer",
  },
  {
    value: "Korean",
    label: "Korean",
  },
  {
    value: "Macedonian",
    label: "Macedonian",
  },
  {
    value: "Maltese",
    label: "Maltese",
  },
  {
    value: "Mandarin",
    label: "Mandarin",
  },
  {
    value: "Nepali",
    label: "Nepali",
  },
  {
    value: "Netherlandic (Dutch)",
    label: "Netherlandic (Dutch)",
  },
  {
    value: "Pashto",
    label: "Pashto",
  },
  {
    value: "Persian",
    label: "Persian",
  },
  {
    value: "Polish",
    label: "Polish",
  },
  {
    value: "Portugese",
    label: "Portugese",
  },
  {
    value: "Punjabi",
    label: "Punjabi",
  },
  {
    value: "Romanian",
    label: "Romanian",
  },
  {
    value: "Russian",
    label: "Russian",
  },
  {
    value: "Serbian",
    label: "Serbian",
  },
  {
    value: "Sinhalese",
    label: "Sinhalese",
  },
  {
    value: "Somali",
    label: "Somali",
  },
  {
    value: "Spanish",
    label: "Spanish",
  },
  {
    value: "Tagalog (Filipino)",
    label: "Tagalog (Filipino)",
  },
  {
    value: "Tamil",
    label: "Tamil",
  },
  {
    value: "Thai",
    label: "Thai",
  },
  {
    value: "Tongan",
    label: "Tongan",
  },
  {
    value: "Turkish",
    label: "Turkish",
  },
  {
    value: "Urdu",
    label: "Urdu",
  },
  {
    value: "Vietnamese",
    label: "Vietnamese",
  },
  {
    value: "Other",
    label: "Other",
  },
];

export const states: TQuestionOption[] = [
  {
    value: "act",
    label: "ACT",
  },
  {
    value: "nsw",
    label: "NSW",
  },
  {
    value: "nt",
    label: "NT",
  },
  {
    value: "qld",
    label: "QLD",
  },
  {
    value: "sa",
    label: "SA",
  },
  {
    value: "tas",
    label: "TAS",
  },
  {
    value: "vic",
    label: "VIC",
  },
  {
    value: "wa",
    label: "WA",
  },
  {
    value: "aus",
    label: "Australia wide",
  },
  {
    label: "Pacific Region",
    value: "pacific-region",
  },
];

export const Concerns = [
  {
    label: "Major development and infrastructure",
    note: "e.g. dams, roads, tunnels, large-scale developments",
    value: "major-development-and-infrastructure",
  },
  {
    label: "Mining, fracking and energy",
    note: "e.g. coal, coal seam gas and power stations",
    value: "mining-fracking-and-energy",
  },
  {
    label: "Local developments and private disputes",
    note: "e.g. trees, fences and buildings",
    value: "local-developments-and-private-disputes",
  },
  {
    label: "Pest and weed control",
    note: "e.g. Pesticides, herbicides and baiting",
    value: "pest-and-weed-control",
  },
  {
    label: "Vegetation clearing and logging",
    note: "e.g. land clearing and forestry",
    value: "vegetation-clearing-and-logging",
  },
  {
    label: "Corporate and government conduct",
    note: "e.g. decision making, access to information",
    value: "Corporate-and-government-conduct",
  },
  {
    label: "Irrigation and water use",
    note: "e.g. rivers, wetlands, drinking water ",
    value: "irrigation-and-water-use",
  },
  {
    label: "Environmental protest",
    note: "e.g. organising protests, police powers and arrest",
    value: "environmental-protest",
  },
  {
    label: "Other",
    note: " e.g. contaminated land or water, public participation processes, private land conservation and law reform processes",
    value: "other",
  },
];

export const Outcomes = [
  {
    label: "Protect Country and culture",
    value: "protect-country-and-culture",
  },
  {
    label: "Protect habitat and wildlife",
    value: "protect-habitat-and-wildlife",
  },
  {
    label: "Address pollution and waste",
    value: "address-pollution-and-waste",
  },
  { label: "Sustainable water sharing", value: "sustainable-water-sharing" },
  { label: "Improve the law", value: "improve-the-law" },
  { label: "Protect human health", value: "protect-human-health" }, // missing on wp
  { label: "Protect property and amenity", value: "protect-property-and-amenity" }, // missing on wp
  { label: "Tackle climate change", value: "tackle-climate-change" },
];

export const AboriginalOrTorresStrait = [
  {
    label: "No, I'm not Aboriginal or Torres Strait Islander",
    value: "no",
  },
  {
    label: "Yes, I'm Aboriginal",
    value: "aboriginal",
  },
  {
    label: "Yes, I'm Torres Strait Islander",
    value: "torres-strait",
  },
  {
    label: "Yes, I'm both Aboriginal and Torres Strait Islander",
    value: "both",
  },
];

export const methodOfContact = [
  {
    label: "Phone",
    value: "phone",
  },
  {
    label: "Email",
    value: "email",
  },
];

export const partyType = [
  {
    label: "Individual",
    value: "individual",
  },
  {
    label: "Company",
    value: "company",
  },
  {
    label: "Local Council",
    value: "local council",
  },
  {
    label: "Government Department",
    value: "government department",
  },
];

export const applyingOnBehalfOf = [
  {
    label: "Incorporated Association",
    value: "incorporated association",
  },
  {
    label: "Community Action Group",
    value: "community action group",
  },
];

export const tellUsMoreOptions = [
  {
    label: "Most or all of my income comes from Centrelink benefits",
    value: "centrelink",
  },
  {
    label: "I earn less than $1000 per week",
    value: "less-1000",
  },
  {
    label: "I live in a  regional or remote area",
    value: "remote-area",
  },
];

export const indivdualOrganisation = [
  { label: "Individual", value: "individual" },
  { label: "Organisation", value: "organisation" },
];

export const courtOrProtesting = [
  {
    label: "Going to court",
    note: "You have been arrested or charged in relation to an environmental protest.",
    value: "Going to court",
  },
  {
    label: "Protesting",
    note: "You are planning a protest activity as an individual or group. ",
    value: "Protesting",
  },
];
